function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  transform: "translate(3 2)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 14.222,
  height: 8.691,
  y: 7.111,
  rx: 1.58
}), React.createElement("path", {
  d: "M3.16 7.111v-3.16A3.952 3.952 0 017.111 0h0a3.95 3.95 0 013.95 3.95v3.161"
}));

var SvgIconLock = function SvgIconLock(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
};

export default SvgIconLock;